(() => {
  const loadVideo = (video) => {
    if (video.dataset.loaded) return;
    video.dataset.loaded = 'true';
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
    });
    video.load();
    video.play().catch(() => { video.controls = true; });
  };
  const videos = document.querySelectorAll('video[data-csc-product-video]');
  if (typeof IntersectionObserver === 'undefined') {
    videos.forEach(loadVideo);
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({target, isIntersecting, intersectionRatio}) => {
      if (!isIntersecting || intersectionRatio < 0.25) return;
      loadVideo(target);
      observer.unobserve(target);
    });
  }, {threshold: 0.25});
  videos.forEach((video) => observer.observe(video));
})();
